module.exports = new __parcel__URL__("phytoplankton-algal-blooms--discovery-cover.eab8a78c.jpg").toString();